import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames/bind';
import get from 'lodash/get';
import SiteComponent from 'yoda-site-components/lib/components/SiteComponent/SiteComponent';
import analyticsAction from 'yoda-site-components/lib/actions/AnalyticsAction';
import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';
import RecommendationSwitch from 'yoda-site-components/lib/components/RecommendationSwitch';
import { selectPreferences } from 'yoda-site-components/lib/selectors/ContextSelector';
import selectProductType from 'yoda-site-components/lib/selectors/productDetails/selectProductType';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import BelowTheFold from '../BelowTheFold/BelowTheFold';
import * as styles from './ProductInfo.css';
import ProductInfo from './ProductInfo';
import CreditCardBanner from '../CreditCardBanner/CreditCardBanner';

const cx = classNames.bind(styles);

export class ProductInfoMobile extends SiteComponent {
    static getDerivedStateFromProps(props, state) {
        const { pageLoadComplete } = props;
        if (pageLoadComplete && !state.pageLoadComplete) {
            return { pageLoadComplete };
        }
        return null;
    }

    static propTypes = {
        dataAutomationId: PropTypes.string,
        productDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        featureFlags: PropTypes.object,
        pageLoadComplete: PropTypes.bool,
    };

    static defaultProps = {
        dataAutomationId: '',
        productDetails: {},
        featureFlags: {},
        pageLoadComplete: false,
    };

    constructor(props) {
        super(props);
        this.state = {
            activeNode: 'prodDesc',
            pageLoadComplete: get(props, 'pageLoadComplete', false),
        };
    }

    /* istanbul ignore next */
    componentDidMount() {
        const {
            featureFlags: { enableShowReviewsButtonOnReviewSection = false },
        } = this.props;
        if (enableShowReviewsButtonOnReviewSection) {
            const reviewSectionButton = document.querySelector(`#accordion-button-0`);
            setTimeout(() => {
                reviewSectionButton?.click();
            }, 500);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.state.pageLoadComplete && !prevProps.pageLoadComplete) {
            const isFromGallery = LocalStorage.getData('fromGallery') || {};
            /* istanbul ignore else */
            if (isFromGallery) {
                /* istanbul ignore else */
                if (isFromGallery.scrollTo === 'reviews') {
                    this.toggleProdInfoSelection('BVSummaryReviewBtn', 'custReview');
                } else if (isFromGallery.scrollTo === 'features') {
                    this.toggleProdInfoSelection('prodDescNode', 'prodDesc');
                }
            }
        }
    }

    toggleProdInfoSelection(node, type) {
        const {
            featureFlags: { enableShopTheLook = true },
        } = this.props;
        const isShopTheLookLoaded = () => document.getElementsByClassName('stylitics-classic-base');
        this.setState({ activeNode: type });
        if (type === 'custReview') {
            const scrollToElem = document.querySelector(`#${node}`);
            if ((enableShopTheLook && isShopTheLookLoaded) || !enableShopTheLook) {
                setTimeout(() => {
                    scrollToElem?.click();
                }, 500);
            }
            LocalStorage.removeData('fromGallery');
        } else if (this[node] && this[node].scrollIntoView) {
            this[node].scrollIntoView({ behavior: 'smooth' });
        }
    }

    /* CoreMedia CMFallback removed */

    render() {
        const {
            productDetails,
            type,
            pageType,
            preferences,
            featureFlags: {
                enableIrisCreditCardBanner,
            },
        } = this.props;
        const recSlots = preferences?.recommendations?.slots || [];
        // Render ONLY slots explicitly tagged for the productInfo zone.
        // `recommendations.slots` merges this page's slots with shared/common slots
        // injected into every microsite; without a strict tag match those common slots
        // (oos/addtocart/rewards) would leak in. So require `zone === 'productInfo'` and
        // never fall back to "render all".
        const productInfoSlots = recSlots.filter((s) => s.zone === 'productInfo');
        const breadcrumbs = get(productDetails, 'breadCrumbInfo.breadcrumbs', []);

        let pdpDivision = '';

        /* istanbul ignore next */
        if (breadcrumbs.length) {
            pdpDivision = get(breadcrumbs, '[1].breadCrumbLabel', '');
        }

        return (
            <BelowTheFold>
                <section className={`${cx('section')} ${dt(['-mx-6'])}`}>
                    <div className={cx('small12', 'medium12', 'large12', 'extraLarge12')}>
                        <ProductInfo
                            dataAutomationId="product-info"
                            productDetails={productDetails}
                            type={type}
                        />
                    </div>
                </section>
                {productInfoSlots.length > 0 ? (
                    <section className={cx('section')}>
                        <div className={cx('certona-row')}>
                            {productInfoSlots.map(slot => (
                                <RecommendationSwitch key={slot.slotId} strategy={slot.slotId} pageType="PDP" itemId={productDetails.id} />
                            ))}
                        </div>
                    </section>
                ) : null}
                {enableIrisCreditCardBanner ? (
                    <section className={cx('section')}>
                        <CreditCardBanner analyticsAction={this.props.analyticsAction} />
                    </section>
                ) : null}
            </BelowTheFold>
        );
    }
}

const mapStateToProps = (store) => ({
    selectProductType: selectProductType(false)(store),
    preferences: selectPreferences(store),
    pageLoadComplete: store?.Analytics?.pageReadyCmpleted || false,
});

const mapDispatchToProps = (dispatch) => ({
    analyticsAction: bindActionCreators(analyticsAction, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductInfoMobile);
